import React from "react";
import SiteWrapper from "../../SiteWrapper.react";
import MetricasTransportistaDashboard from "./Dashboards/MetricasTransportista/MetricasTransportistaDashboard";

const MetricasTransportista = () => {
  return (
    <SiteWrapper>
      <MetricasTransportistaDashboard />
    </SiteWrapper>
  );
};

export default MetricasTransportista;
